import { api_get, api_post } from './lfApi.js';

export async function createShare(studyPlanId, sharerDisplayName, setError = null) {
    try {
        const response = await api_post('/share/study_plan', {
            study_plan_id: studyPlanId,
            sharer_display_name: sharerDisplayName,
        }, setError);
        if (response && response.status === 200) {
            return response.data;
        }
        else {
            console.error('Failed to create share');
        }
    }
    catch (error) {
        console.error('Error creating share:', error);
    }
    return null;
}

export async function getShare(token, setError = null) {
    try {
        const response = await api_get(`/share/study_plan/${token}`, {}, setError);
        if (response && response.status === 200) {
            return response.data;
        }
        else {
            console.error('Failed to fetch share');
        }
    }
    catch (error) {
        console.error('Error fetching share:', error);
    }
    return null;
}

export async function importShare(token, targetChildProfileIds, setError = null) {
    try {
        const response = await api_post(`/share/study_plan/${token}/import`, {
            target_child_profile_ids: targetChildProfileIds,
        }, setError);
        if (response && response.status === 200) {
            return response.data;
        }
        else {
            console.error('Failed to import share');
        }
    }
    catch (error) {
        console.error('Error importing share:', error);
    }
    return null;
}

export async function getMyShares(setError = null) {
    try {
        const response = await api_get('/share/study_plan/mine', {}, setError);
        if (response && response.status === 200) {
            return response.data;
        }
        else {
            console.error('Failed to fetch my shares');
        }
    }
    catch (error) {
        console.error('Error fetching my shares:', error);
    }
    return null;
}
